var React = require('react');

function InfoGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_info_24px","fill":"#b1b1b1","d":"M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Zm.6,9H7.4V7.4H8.6Zm0-4.8H7.4V5H8.6Z","transform":"translate(-2 -2)"}));
}

InfoGrey.defaultProps = {"viewBox":"0 0 12 12"};

module.exports = InfoGrey;

InfoGrey.default = InfoGrey;
